<template>
  <ida-survey-note
    v-if="survey.shape"
    :shape="survey.shape"
    :answers="answers"
    :noteColor="survey.noteColor"
    :btnColor="survey.color"
    :value="userVotes"
    @click="handleClick"
    :locale="survey.locale"
    :displayVotesCount="survey.displayVotesCount">
    <template slot="title">{{ question }}</template>
    <template slot="question" v-if="description">{{ description }}</template>
  </ida-survey-note>
</template>

<script>
import { mapGetters } from 'vuex'
import styles from '@/assets/styles/styles.scss'

export default {
  name: 'iDalgo-Survey-Note',
  computed: {
    ...mapGetters({
      survey: 'survey/survey',
      hasVoted: 'survey/hasVoted',
      questions: 'survey/questions',
      userVotes: 'survey/userVotes',
      currentQuestion: 'survey/currentQuestion'
    }),
    question () { return this.questions[this.currentQuestion] ? this.questions[this.currentQuestion].title : null },
    description () { return this.questions[this.currentQuestion] ? this.questions[this.currentQuestion].description : null },
    answers () { return this.$store.getters['survey/answers'](0) }
  },
  methods: {
    handleClick (userVotes) {
      this.$emit('click', userVotes)
    }
  },
  data () {
    return {
      styles
    }
  },
  mounted () {
    window.onresize = () => { this.width = window.innerWidth < 420 ? window.innerWidth - 80 : 340 }
    window.addEventListener('mousemove', this.handleMouse)
  }
}
</script>
